export default __webpack_public_path__ + "static/media/blue_black.89d95265.svg";